import { toastedError, toastedSuccess } from "../config/toast";

export const shareTextOf = async (txt) => {
     if (!navigator.share) {
          toastedError("Sharing not supported here.");
          return;
     }

     try {
          await navigator.share({ text: txt });
          toastedSuccess("Shared successfully");
     } catch (err) {
          if (err.name !== "AbortError") {
               console.error(err);
               toastedError("Something went wrong while sharing.");
          }
     }
};


// Formats Firestore Timestamp or string date to "13 Dec 2025"

export const formatCreatedAt = (createdAt) => {
     if (!createdAt) return "—";

     // 🔹 Firestore Timestamp
     if (typeof createdAt === "object" && createdAt.seconds) {
          const date = new Date(createdAt.seconds * 1000);
          return date.toLocaleDateString("en-IN", {
               day: "2-digit",
               month: "short",
               year: "numeric",
          });
     }

     // 🔹 String date
     if (typeof createdAt === "string") {
          try {
               // "13/12/2025, 10:30:45"
               if (createdAt.includes(",")) {
                    const [datePart] = createdAt.split(",");
                    const [day, month, year] = datePart.split("/").map(Number);
                    return new Date(year, month - 1, day).toLocaleDateString("en-IN", {
                         day: "2-digit",
                         month: "short",
                         year: "numeric",
                    });
               }

               // "13/12/2025"
               const [day, month, year] = createdAt.split("/").map(Number);
               return new Date(year, month - 1, day).toLocaleDateString("en-IN", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
               });
          } catch {
               return "—";
          }
     }

     return "—";
};


// getReadTime export functions
export const getReadTime = (text) => {
     if (!text) return '1 min read';
     const words = text.trim().split(/\s+/).length;
     const readTime = Math.max(1, Math.ceil(words / 180));
     return `${readTime} min read`;
};



export const formatTimeAgo = (timestamp) => {
     if (!timestamp?.seconds) return 'Just now';

     const now = Date.now();
     const created = timestamp.seconds * 1000;
     const diffMs = now - created;

     const minutes = Math.floor(diffMs / (1000 * 60));
     const hours = Math.floor(diffMs / (1000 * 60 * 60));
     const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));

     if (minutes < 1) return 'Just now';
     if (minutes < 60) return `${minutes} min ago`;
     if (hours < 24) return `${hours} hour${hours > 1 ? 's' : ''} ago`;
     return `${days} day${days > 1 ? 's' : ''} ago`;
};